import { z } from "zod";
/**
 * Definition of a user profile as inspectable by other users (i.e. reduced version)
 */
export const DTOUserProfile = z.object({
    name: z.string(),
    nickname: z.string().optional(),
    avatar: z.string().optional(),
});
/**
 * Definition of a user as inspectable by other users (i.e. reduced version)
 */
export const DTOUser = z.object({
    id: z.string(),
    email: z.string(),
    profile: DTOUserProfile,
});
export const DTOUserGetResponse = z.object({
    user: DTOUser,
});
